(() => {
  const initialize = (root = document) => {
    const videos = root.querySelectorAll('.tw-product-reels__video:not([data-tw-reel-ready])');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.dataset.twPoster) {
              video.poster = video.dataset.twPoster;
              delete video.dataset.twPoster;
            }
            if (!video.dataset.twSourcesReady) {
              video.querySelectorAll('[data-tw-src]').forEach((source) => {
                source.src = source.dataset.twSrc;
                delete source.dataset.twSrc;
              });
              video.dataset.twSourcesReady = 'true';
              video.load();
            }
            video.preload = 'metadata';
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) {
              video.play().catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '300px 0px', threshold: 0.05 }
    );

    videos.forEach((video) => {
      video.dataset.twReelReady = 'true';
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
